const STORAGE_KEY_PREFFIX = 'sot-us-acute:';

/***KEEEP ALL STORAGE KEYS HERE*****/
export const STORAGE_KEYS = {
  APP_TOKEN: 'APP_TOKEN',
  ACTIVE_FACILITY: 'ACTIVE_FACILITY',
};
/********************************/

/************MARK THE REQUIRED /  MANDATORY STORAGE KEYS *****************/
const MAP_KEYS_NAMES = {
  [STORAGE_KEYS.APP_TOKEN]: `${STORAGE_KEY_PREFFIX}token`,
  [STORAGE_KEYS.ACTIVE_FACILITY]: `${STORAGE_KEY_PREFFIX}active-facility`,
};
export const REQUIRED_STORAGE_KEYS = [STORAGE_KEYS.APP_TOKEN];
/***********************************************************************/

type Key = string;
type Value = any;

function StorageInstance(
  storageType: 'localStorage' | 'sessionStorage' = 'localStorage'
) {
  const storage =
    storageType === 'sessionStorage' ? sessionStorage : localStorage;
  return {
    setItem: (key: Key, value: Value) =>
      storage.setItem(MAP_KEYS_NAMES[key], JSON.stringify(value ?? null)),
    getItem: (key: Key) => {
      const newValue: string | null =
        storage.getItem(MAP_KEYS_NAMES[key]) !== 'undefined'
          ? storage.getItem(MAP_KEYS_NAMES[key])
          : null;
      return newValue !== null ? JSON.parse(newValue) : newValue;
    },
    removeItem: (key: Key) => storage.removeItem(MAP_KEYS_NAMES[key]),
    clear: () => {
      for (const storageKey in storage) {
        if (storageKey.indexOf(STORAGE_KEY_PREFFIX) !== -1)
          storage.removeItem(storageKey);
      }
    },
  };
}
export const Storage = StorageInstance('sessionStorage');
